import { newUuid } from '@krp/client-runtime'

import type { CommandAttempt } from './types'

/** Новый идентификатор — генератор client-runtime (с запасным путём вне secure context). */
export const newId = (): string => newUuid()

/**
 * Ключи команды создаются ОДИН раз на намерение человека и переживают повтор
 * после неизвестного исхода: сервер по ним отдаёт прежний итог, а не создаёт
 * вторую запись (ADR-11).
 */
export function newCommandAttempt(): CommandAttempt {
  return { operationId: newId(), idempotencyKey: newId() }
}
